import { IpAddress, MacAddress, SnmpOid } from "DiscoveryEngine.TS/Core";

export class DeviceListEntry {
	public dataKey: string;
	public name: string;
	public ipAddress: string;
	public macAddress: string;
	public description: string;
	public snmpOid: string;
	public vendor: string;
	public notes: string;

	public ipAddressTag: IpAddress;
	public get hasIpAddressTag(): boolean {
		return !!this.ipAddressTag;
	}

	public macAddressTag: MacAddress;
	public get hasMacAddressTag(): boolean {
		return !!this.macAddressTag;
	}

	public snmpOidTag: SnmpOid;
	public get hasSnmpOidTag(): boolean {
		return !!this.snmpOidTag;
	}

	public deviceGuid: string;
	public get hasDeviceGuid(): boolean {
		return !!this.deviceGuid;
	}

	constructor() {
		this.dataKey = "";
		this.name = "";
		this.ipAddress = "";
		this.macAddress = "";
		this.description = "";
		this.snmpOid = "";
		this.vendor = "";
		this.notes = "";

		this.ipAddressTag = null;
		this.macAddressTag = null;
		this.snmpOidTag = null;

		this.deviceGuid = "";
	}
}
